import { FC } from 'react';

import { GroupsPlaceholder, IGroupsPlaceholderProps } from '@gem/components';

type IUsersPlaceholderProps = IGroupsPlaceholderProps;

export const UsersPlaceholder: FC<IUsersPlaceholderProps> = (props) => {
  return <GroupsPlaceholder {...props} />;
};
